import { create } from "zustand"

interface WidgetsHospitalStore {
  selectedTab: "review" | "treatmentCase" | "hospitalInfo"
  setSelectedTab: (selectedTab: "review" | "treatmentCase" | "hospitalInfo") => void
}

const useWidgetsHospitalStore = create<WidgetsHospitalStore>((set) => ({
  selectedTab: "review",
  setSelectedTab: (selectedTab: "review" | "treatmentCase" | "hospitalInfo") => set({ selectedTab }),
}))

export default useWidgetsHospitalStore